import {Component, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {ModalDirective} from 'ng2-bootstrap';
import {Subscription, timer} from 'rxjs';

import {Event, EventId} from 'app/models/base/event';
import {WebMethodResult} from '../../../models/web-method-result';


import {SecurityService} from '../../../services/settings/security.service';
import {ClientSettingsService} from '../../../services/settings/client-settings.service';
import {BaseComponent} from '../../base/base.component';
import {AppModulePath} from '../../../models/app-module-path';
import {Company} from '../../../models/lookups/company';
import {Stockroom} from '../../../models/stockroom/stockroom';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng';
import {isNil} from 'lodash';

// import { UserCalendarComponent } from "app/components/ui/user-calendar/user-calendar.component";

@Component({
  selector: 'bms-proizvodnja',
  templateUrl: './proizvodnja.component.html',
  styleUrls: ['./proizvodnja.component.scss']
})
export class ProizvodnjaComponent extends BaseComponent implements OnInit {
  afterLogin: boolean;
  username: string;
  activeUserId: number;
  activeCompany: Company;
  activeStockroom: Stockroom;
  @ViewChild('chooseCSDialog', {static: false})
  chooseCSDialog: ModalDirective;
  @ViewChild('companyDialog', {static: false}) companyDialog: ModalDirective;
  showCalendar: boolean;
  appModulePath: typeof AppModulePath;
  changeActiveStockroomSubscription: Subscription;
  appType: number = 0;

  menuItems: MenuItem[] = [];

  constructor(private clientSettings: ClientSettingsService,
              public securityService: SecurityService,
              public router: Router,
              private location: Location) {
    super();
    this.appModulePath = AppModulePath;
    this.buildMenuItems();

    this.showCalendar = true;
    router.events.subscribe((val) => {
      // console.log(location.path());
      if (location.path() !== '/ng/proizvodnja') {
        this.showCalendar = false;
      } else {
        this.showCalendar = true;
      }
    });
  }


  ngOnInit() {
    const stored = localStorage.getItem('appType');
    this.appType = stored ? Number(stored) : 0;
    this.changeActiveStockroomSubscription = this.clientSettings.onChangeActiveStockroom.subscribe(
      () => {
        this.activeStockroom = this.clientSettings.getActiveStockroom();
        this.clientSettings.setActiveStockroom(this.activeStockroom);
      }
    );

    this.securityService.fetchLoggerUser().subscribe(
      data => {
        this.translateSvc.use(this.securityService.loggedUser.uiLang);
        this.buildMenuItems();
        this.username = this.securityService.loggedUser.fullName();
        this.activeUserId = this.securityService.loggedUser.id;
        this.activeCompany = this.clientSettings.getActiveCompany();
        this.activeStockroom = this.clientSettings.getActiveStockroom();

        if ((this.activeCompany !== null && this.activeCompany.id === null) ||
          (this.activeStockroom !== null && this.activeStockroom.id === null)) {
          this.afterLogin = true;

          timer(1000).subscribe(() => {
            if (!isNil(this.chooseCSDialog)) {
              this.chooseCSDialog.show();
            }
          });
        } else {
          this.clientSettings.setActiveCompany(this.activeCompany);
          this.clientSettings.setActiveStockroom(this.activeStockroom);
        }
      });

  }

  onLogout() {
    this.securityService.logout().subscribe(
      success => window.location.reload()
    );
  }

  canAccessEotpremnicaInternoIzdavanje(): boolean {
    return !!this.activeStockroom && !!this.activeStockroom.eUprava;
  }

  private buildMenuItems(): void {
    const activeLang = this.securityService.loggedUser ? this.securityService.loggedUser.uiLang : 'sr-Latn';
    this.transl([
      'home.menu.logout',
      'home.menu.english',
      'home.menu.serbianLatin',
      'home.menu.serbianCyrillic'
    ]).subscribe(t => {
      this.menuItems = [
        {
          label: t.homeMenuLogout,
          icon: 'fa fa-sign-out',
          command: () => {
            this.onLogout();
          }
        },
        {label: '', separator: true},
        {
          label: t.homeMenuEnglish,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'en'),
          command: () => {
            this.onLanguageChange('en');
          }
        },
        {
          label: t.homeMenuSerbianLatin,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Latn'),
          command: () => {
            this.onLanguageChange('sr-Latn');
          }
        },
        {
          label: t.homeMenuSerbianCyrillic,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Cyrl'),
          command: () => {
            this.onLanguageChange('sr-Cyrl');
          }
        }];
    });
  }

  private getLanguageMenuItemClass(activeLang: string, lang: string): string {
    return activeLang === lang ? 'user-menu-language user-menu-language-selected' : 'user-menu-language';
  }

  showChooseCSDialog() {
    this.afterLogin = false;
    this.chooseCSDialog.show();
  }

  showCompanyDialog() {
    this.companyDialog.show();
  }

  onEvent(event: Event) {
    if (event.id === EventId.DIALOG_OK) {
      this.activeCompany = event.object.company;
      this.activeStockroom = event.object.stockroom;

      this.clientSettings.setActiveCompany(this.activeCompany);
      this.clientSettings.setActiveStockroom(this.activeStockroom);

      if (this.afterLogin) {
        this.router.navigate(['ng/home']);
      }
    } else if (event.id === EventId.DIALOG_CANCEL && this.afterLogin) {
      this.displayErrorPage('Niste izabrali ni kompaniju ni magacin!');
      // this.router.navigate(['ng/error'], {
      //   queryParams: {
      //     errorObj: JSON.stringify(WebMethodResult.create(-1, 'Niste izabrali ni kompaniju ni magacin!'))
      //   }
      // });
    }
    this.chooseCSDialog.hide();
    this.companyDialog.hide();
  }

  private onLanguageChange(lang: string) {
    this.securityService.loggedUser.uiLang = lang;
    this.securityService.setLang(this.securityService.loggedUser.lang).subscribe({
      next: () => {
        this.translateSvc.use(lang);
        this.buildMenuItems();
      },
      error: (err) => {
        this.setError(err);
      }
    });
  }
}
